<template>
  <v-card class="elevation-2">
    <v-card-text>
      <ValidationObserver ref="userProfileForm">
        <v-row>
          <v-col cols="12" md="6" class="px-3">

            <validatable-text-input
                v-test="{ input: 'inn' }"
                :value="profileInfo.inn"
                :readonly="readonly"
                :rules="{ required: !profileInfo.ogrn,
                          max: 100 }"
                prepend-icon="device_hub"
                :label="$t('ИНН')"
                @input="mergeProfile({ inn: $event })" />
            <validatable-text-input
                v-test="{ input: 'ogrn' }"
                :value="profileInfo.ogrn"
                :rules="{ required: !profileInfo.inn,
                          max: 100 }"
                :readonly="readonly"
                :label="$t('ОГРН/КИО')"
                @change="mergeProfile({ ogrn: $event })" />
            <validatable-checkbox
                v-test="{ checkbox: 'subscriptions' }"
                :value="subscriptions"
                :readonly="readonly"
                rules="required"
                :label="$t('Подписка на рассылку')"
                prepend-icon="mail"
                @change="changeSubscriptions" />
          </v-col>
          <v-col cols="12" md="6" class="px-3">
            <validatable-text-input
                v-test="{ input: 'phone' }"
                :value="profileInfo.phone"
                :readonly="readonly"
                :rules="{ required: true,
                          regex: /^[+]?[\d\s(\-);,]+$/ }"
                :label="$t('Контактный телефон')"
                prepend-icon="settings_phone"
                :type="'tel'"
                @input="mergeProfile({ phone: $event })" />
            <validatable-text-input
                v-test="{ input: 'contactPerson' }"
                :value="profileInfo.contactPerson"
                :readonly="readonly"
                rules="required"
                :label="$t('Контактное лицо')"
                prepend-icon="person"
                @input="mergeProfile({ contactPerson: $event })" />
            <!-- <validatable-document-person-identity
                v-test="{ input: 'documentPersonIdentity' }"
                :value="profileInfo.documentPersonIdentity"
                :rules="{ required: true,
                          regex: /^\d{4}\s{1}\d{6}$/ }"
                :readonly="readonly"
                prepend-icon="assignment_ind"
                @input="mergeProfile({ documentPersonIdentity: $event })" /> -->
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-card-text>
  </v-card>
</template>

<script>
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableCheckbox from '@/components/reused/ui/ValidatableCheckbox.vue'
  // import ValidatableDocumentPersonIdentity from '@/components/reused/ui/ValidatableDocumentPersonIdentity.vue'
  import { SUBSCRIPTION_TYPES } from '@/constants/business'
  import { mapMutations } from 'vuex'
  import { USER_PROFILE } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      ValidatableCheckbox
      // ValidatableDocumentPersonIdentity
    },
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      saveMethod: {
        type: Function
      },
      profileInfo: {
        type: Object,
        required: true
      }
    },
    computed: {
      subscriptions () {
        return this.profileInfo.subscriptionsStatus === SUBSCRIPTION_TYPES.FULL
      }
    },
    methods: {
      ...mapMutations(USER_PROFILE.NAMESPACE, {
        mergeProfileMutation: USER_PROFILE.MUTATIONS.MERGE_PROFILE
      }),
      validate: async function () {
        return await this.$refs.userProfileForm.validate()
      },
      mergeProfile: function (objWithEditedProps) {
        this.mergeProfileMutation(objWithEditedProps)
      },
      changeSubscriptions: function (enabled) {
        const subscriptionsStatus = enabled
          ? SUBSCRIPTION_TYPES.FULL
          : SUBSCRIPTION_TYPES.NONE
        this.mergeProfileMutation({ subscriptionsStatus })
      }
    }
  }
</script>
